import { apiClient } from './apiClient';
import type { LegalForm, TPayCategory } from '../types/businessProfile';

export const tpayService = {
  /**
   * Get TPay legal forms dictionary
   */
  async getLegalForms(token: string): Promise<LegalForm[]> {
    return apiClient.get<LegalForm[]>(
      '/tpay/dictionaries/legal-forms',
      token
    );
  },

  /**
   * Get TPay categories dictionary
   */
  async getCategories(token: string): Promise<TPayCategory[]> {
    return apiClient.get<TPayCategory[]>(
      '/tpay/dictionaries/categories',
      token
    );
  },
};
